import { render, staticRenderFns } from "./SearchNpa.vue?vue&type=template&id=28badfc8"
import script from "./SearchNpa.vue?vue&type=script&lang=js"
export * from "./SearchNpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports